export const isEmpty = (str) => {
    return str === null || str === undefined || str == ''
}